import { Edit, Remove } from "@app/components/Actions";
import pathRoutes from "../../../../routes/pathRoutes";
import { useMasterTables } from "../useMasterTables";
import { PermissionComponentGate } from "@app/utils/PermissionComponentGate";
import { RolesTypes } from "@app/pages/users/utils/helpers";

export const columnsIsotopos = (keysTables: string[], tableName: string) => [
  {
    field: "id",
    headerName: "id",
    headerAlign: "center",
    align: "left",
    flex: 0,
  },
  {
    field: "codigo",
    headerName: "Codigo",
    headerAlign: "center",
    align: "left",
    flex: 1,
  },
  {
    field: "simbolo",
    headerName: "Símbolo",
    headerAlign: "center",
    align: "left",
    flex: 1,
  },
  {
    field: "masa",
    headerName: "Masa",
    headerAlign: "center",
    align: "left",
    flex: 1,
  },
  {
    field: "metaestable",
    headerName: "Metaestable",
    headerAlign: "center",
    align: "left",
    flex: 1,
  },
  {
    field: "cdes",
    headerName: "Cdes",
    headerAlign: "center",
    align: "left",
    flex: 1,
  },
  {
    field: "gammades",
    headerName: "Gammades",
    headerAlign: "center",
    align: "left",
    flex: 1,
  },
  {
    field: "ugammades",
    headerName: "Ugammades",
    headerAlign: "center",
    align: "left",
    flex: 1,
  },
  {
    field: "factor351",
    headerName: "Factor 354",
    headerAlign: "center",
    align: "left",
    flex: 1,
  },
  {
    field: "factor911",
    headerName: "Factor 911",
    headerAlign: "center",
    align: "left",
    flex: 1,
  },
  {
    field: "nra",
    headerName: "Nra",
    headerAlign: "center",
    align: "left",
    flex: 1,
  },
  {
    field: "origen",
    headerName: "Origen",
    headerAlign: "center",
    align: "left",
    flex: 1,
  },
  {
    field: "periodo",
    headerName: "Periodo",
    headerAlign: "center",
    align: "left",
    flex: 1,
  },
  {
    field: "uperiodo",
    headerName: "Uperiodo",
    headerAlign: "center",
    align: "left",
    flex: 1,
  },
  {
    field: "energia",
    headerName: "Energía",
    headerAlign: "center",
    align: "left",
    flex: 1,
  },
  {
    field: "activo",
    headerName: "Activo",
    headerAlign: "center",
    align: "left",
    flex: 1,
  },
  {
    field: "actions",
    headerName: "Acciones",
    headerAlign: "center",
    align: "left",
    flex: 1,
    renderCell: (params: any) => (
      <>
        <PermissionComponentGate
          permissions={[RolesTypes.ADMIN, RolesTypes.SUPER_ADMIN]}
        >
          <Edit
            to={`${pathRoutes.ADMIN_MASTER_TABLES}/editar/${tableName}/${params.id}`}
          />
          <Remove
            onRemove={() =>
              useMasterTables.getState().deleteData(params.id, tableName)
            }
            title="Va a borrar de forma permanente este registro"
            text="¿Quiere continuar?"
          />
        </PermissionComponentGate>
      </>
    ),
  },
];
